import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EnquiryTypeForm from '../../../components/forms/EnquiryTypeForm';
import { useEnquiryTypeApi } from '../../../hooks/useEnquiryTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { EnquiryTypeDTO } from '../../../services/apiClient';

const EnquiryTypeEdit: React.FC = () => {
  const { getById, edit } = useEnquiryTypeApi();
  const [entityData, setEntityData] = useState<EnquiryTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Enquiry Types', href: '/admin/enquirytypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching EnquiryType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/enquirytypes');
    } catch (error) {
      console.error('Error updating EnquiryType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/enquirytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EnquiryType.Edit"
    >
      {entityData ? (
        <EnquiryTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/enquirytypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default EnquiryTypeEdit;
